import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useMemberChargesSubscriptionsQuery = createQueryHook(
  MembershipsCreatorApiClient.getMemberChargesSubscriptions,
  {
    queryKey: ['memberChargesSubscriptions'],
  },
)
